export default "__VITE_ASSET__51e296e3__"